import { Button, Checkbox, Col, Row, Input } from "antd";
import { Collapse } from "../components/Collapse";
import { Segmented } from "../components/Segmented";
import { Tabs } from "../components/Tabs";
import { DealScore } from "../components/DealScore";
import { SimpleCard } from "../components/SimpleCard";
import { Alert } from "../components/Alert/Alert";
import { Space } from "../components/Space";

export const ProjectComponents = [
    {
        title: "Segmented",
        components: [
            {
                title: "Default",
                component: (
                    <Segmented
                        options={[
                            { label: "Intake", value: "intake" },
                            { label: "Summary", value: "summary" },
                            { label: "Analysis", value: "analysis" },
                        ]}
                    />
                ),
            },
            {
                title: "Disabled",
                component: (
                    <Segmented
                        options={[
                            { label: "Intake", value: "intake" },
                            { label: "Summary", value: "summary", disabled: true },
                            { label: "Analysis", value: "analysis" },
                        ]}
                    />
                ),
            },
        ],
    },
    {
        title: "Tabs",
        components: [
            {
                title: "Default",
                component: (
                    <Tabs
                        items={[
                            { label: "Intake", key: "intake" },
                            { label: "Summary", key: "summary" },
                            { label: "Analysis", key: "analysis" },
                        ]}
                    />
                ),
            },
            {
                title: "Disabled",
                component: (
                    <Tabs
                        items={[
                            { label: "Intake", key: "intake" },
                            { label: "Summary", key: "summary", disabled: true },
                            { label: "Analysis", key: "analysis" },
                        ]}
                    />
                ),
            },
        ],
    },
    {
        title: "Collapse",
        components: [
            {
                title: "Default",
                component: (
                    <Collapse>
                        <Collapse.Panel
                            title="Contract summary"
                            description="Here's a summary of your contract."
                            key="1"
                        >
                            Contract summary
                        </Collapse.Panel>
                        <Collapse.Panel
                            title="Negotiation strategy"
                            description="Potential cost-savings strategy checklist."
                            key="2"
                        >
                            Negotiation strategy
                        </Collapse.Panel>
                        <Collapse.Panel
                            title="Top legal priorities"
                            description="Critical legal issues and strategies that demand immediate attention."
                            key="3"
                        >
                            Top legal priorities
                        </Collapse.Panel>
                    </Collapse>
                ),
            },
        ],
    },
    {
        title: "Deal Score",
        components: [
            {
                title: "Default",
                component: (
                    <Row gutter={[0, 36]}>
                        <Col span={24}>
                            <DealScore score={0} orderFormId={0} optimizedScore={100} />
                        </Col>
                        <Col span={24}>
                            <DealScore score={25} orderFormId={0} />
                        </Col>
                        <Col span={24}>
                            <DealScore score={50} orderFormId={0} optimizedScore={95.5} />
                        </Col>
                        <Col span={24}>
                            <DealScore score={75} orderFormId={0} optimizedScore={100} />
                        </Col>
                        <Col span={24}>
                            <DealScore score={100} orderFormId={0} optimizedScore={100} />
                        </Col>
                    </Row>
                ),
            },
            {
                title: "Without Navigation",
                component: (
                    <Row gutter={[0, 36]}>
                        <Col span={24}>
                            <DealScore score={0} optimizedScore={100} />
                        </Col>
                        <Col span={24}>
                            <DealScore score={25} />
                        </Col>
                        <Col span={24}>
                            <DealScore score={50} optimizedScore={95.5} />
                        </Col>
                        <Col span={24}>
                            <DealScore score={75} optimizedScore={100} />
                        </Col>
                        <Col span={24}>
                            <DealScore score={100} optimizedScore={100} />
                        </Col>
                    </Row>
                ),
            },
        ],
    },
    {
        title: "Simple Card",
        components: [
            {
                title: "Without Header",
                component: (
                    <Row gutter={16}>
                        <Col span={6}>
                            <SimpleCard>Default Card</SimpleCard>
                        </Col>
                        <Col span={6}>
                            <SimpleCard type="white">White Card</SimpleCard>
                        </Col>
                        <Col span={6}>
                            <SimpleCard type="primary">Primary Card</SimpleCard>
                        </Col>
                        <Col span={6}>
                            <SimpleCard type="success">Success Card</SimpleCard>
                        </Col>
                    </Row>
                ),
            },
            {
                title: "With Header",
                component: (
                    <Row gutter={16}>
                        <Col span={8}>
                            <SimpleCard header="Default Header">Content</SimpleCard>
                        </Col>
                        <Col span={8}>
                            <SimpleCard header="Primary Header" headerType="primary">
                                Content
                            </SimpleCard>
                        </Col>
                        <Col span={8}>
                            <SimpleCard header="Success Header" headerType="success">
                                Content
                            </SimpleCard>
                        </Col>
                    </Row>
                ),
            },
            {
                title: "With Customized Header",
                component: (
                    <Row gutter={16}>
                        <Col span={12}>
                            <SimpleCard
                                header={
                                    <Row justify="space-between">
                                        <span>Deal analysis</span>
                                        <Button size="small" type="primary">
                                            Create PDF
                                        </Button>
                                    </Row>
                                }
                                headerType="primary"
                            >
                                Content
                            </SimpleCard>
                        </Col>
                        <Col span={12}>
                            <SimpleCard
                                header={
                                    <Row justify="space-between">
                                        <span>Q1</span>
                                        <Checkbox />
                                    </Row>
                                }
                            >
                                Content
                            </SimpleCard>
                        </Col>
                    </Row>
                ),
            },
        ],
    },
    {
        title: "Alert",
        components: [
            {
                title: "Default",
                component: (
                    <Row gutter={[0, 36]}>
                        <Col span={24}>
                            <Alert message="Info" />
                        </Col>
                        <Col span={24}>
                            <Alert message="Success" type="success" />
                        </Col>
                        <Col span={24}>
                            <Alert message="Warning" type="warning" />
                        </Col>
                        <Col span={24}>
                            <Alert message="Error" type="error" />
                        </Col>
                    </Row>
                ),
            },
            {
                title: "With Description",
                component: (
                    <Row gutter={[0, 36]}>
                        <Col span={24}>
                            <Alert message="Info" description="Info Description" />
                        </Col>
                        <Col span={24}>
                            <Alert
                                message="Success"
                                type="success"
                                description="Success Description"
                            />
                        </Col>
                        <Col span={24}>
                            <Alert
                                message="Warning"
                                type="warning"
                                description="Warning Description"
                            />
                        </Col>
                        <Col span={24}>
                            <Alert message="Error" type="error" description="Error Description" />
                        </Col>
                    </Row>
                ),
            },
            {
                title: "With Icon",
                component: (
                    <Row gutter={[0, 36]}>
                        <Col span={24}>
                            <Alert message="Info" description="Info Description" showIcon />
                        </Col>
                        <Col span={24}>
                            <Alert
                                message="Success"
                                type="success"
                                description="Success Description"
                                showIcon
                            />
                        </Col>
                        <Col span={24}>
                            <Alert
                                message="Warning"
                                type="warning"
                                description="Warning Description"
                                showIcon
                            />
                        </Col>
                        <Col span={24}>
                            <Alert
                                message="Error"
                                type="error"
                                description="Error Description"
                                showIcon
                            />
                        </Col>
                    </Row>
                ),
            },
            {
                title: "With Close Icon",
                component: (
                    <Row gutter={[0, 36]}>
                        <Col span={24}>
                            <Alert
                                message="Info"
                                description="Info Description"
                                showIcon
                                closable
                            />
                        </Col>
                        <Col span={24}>
                            <Alert
                                message="Success"
                                type="success"
                                description="Success Description"
                                showIcon
                                closable
                            />
                        </Col>
                        <Col span={24}>
                            <Alert
                                message="Warning"
                                type="warning"
                                description="Warning Description"
                                showIcon
                                closable
                            />
                        </Col>
                        <Col span={24}>
                            <Alert
                                message="Error"
                                type="error"
                                description="Error Description"
                                showIcon
                                closable
                            />
                        </Col>
                    </Row>
                ),
            },
        ],
    },
    {
        title: "Space",
        components: [
            {
                title: "Default",
                component: (
                    <Space direction="vertical">
                        <Input placeholder="Input 1" />
                        <Input placeholder="Input 2" />
                    </Space>
                ),
            },
            {
                title: "Full Width",
                component: (
                    <Space direction="vertical" fullWidth>
                        <Input placeholder="Input 1" />
                        <Input placeholder="Input 2" />
                    </Space>
                ),
            },
        ],
    },
];
